export const BRAND = {
  name: 'Broken Planet',
  supportEmail: 'support@brokenplanet.com',
  location: {
    city: 'London',
    country: 'GB',
  },
  priceRange: '££',
  socials: {
    instagram: 'https://www.instagram.com/brokenplanet/',
    tiktok: 'https://www.tiktok.com/@brokenplanet',
    pinterest: 'https://www.pinterest.com/brokenplanet/',
  },
};

export const SEO = {
  brandName: BRAND.name,
  defaultTitle: `${BRAND.name} | Official Site`,
  defaultDescription:
    'The official home of sustainable streetwear. Limited drops monthly. Oversized fits. Eco-friendly materials.',
  defaultOgImage: '/og-image.png',
  defaultOgImageWidth: 1200,
  defaultOgImageHeight: 600,
  defaultOgImageAlt: 'Broken Planet logo',
  twitterCard: 'summary_large_image' as const,
};

export const FALLBACK_SITE_URL = 'https://brokenplanet.com';

/**
 * The meta half of `NOINDEX_HEADERS` (`gatedRoutes.ts`), for routes that must
 * stay out of the index: the password gates and the marketing landing page.
 *
 * Only the tags are shared, not a whole `meta` array — titles legitimately
 * differ (a gated PDP builds its own from the product). Spread it after the
 * title: `meta = () => [{ title: SEO.brandName }, ...NOINDEX_META_TAGS]`.
 *
 * On `/private-sale-sign-up` this is the ACTUAL indexing control; `robots.txt`
 * only stops crawling, not indexing of a URL discovered through an ad link.
 */
export const NOINDEX_META_TAGS = [
  { name: 'robots', content: 'noindex, nofollow' },
  { name: 'referrer', content: 'strict-origin-when-cross-origin' },
];
